<template>
  <div class="fixed inset-0 z-50 flex items-end justify-center px-4 py-8 pointer-events-none sm:p-8">
    <div class="w-full max-w-sm">
      <u-notification
        v-for="notification in notifications"
        :key="notification.id"
        class="mt-4"
        :type="notification.type"
        :title="notification.title"
        :description="notification.description"
        @close="close(notification.id)"
        @click="close(notification.id)"
      />
    </div>
  </div>
</template>

<script setup>
import UNotification from '../Notification/Notification.vue';
import useNotifications from '../../composables/useNotifications';

const { notifications, removeNotification } = useNotifications();

const close = (id) => {
  // Emitting a close event (if needed in a parent component)
  // can be done via the emit function in Vue 3.
  // It's outside the scope of this example but if needed you can do:
  // const emit = defineEmits(['close']);
  // emit('close');

  removeNotification(id);
};
</script>
